export default class TypewriterAnimator {
  constructor() {
    this.elements = document.querySelectorAll('.gr-typewriter');
    this.observer = new IntersectionObserver(this.typeEffect.bind(this), {
      threshold: 0.2,
    });
    this.observeElements();
  }

  observeElements() {
    this.elements.forEach((el) => {
      this.prepareElement(el);
      this.observer.observe(el);
    });
  }

  prepareElement(el) {
    const text = el.textContent.trim();
    el.innerHTML = '';
  
    text.split('').forEach((char, index) => {
      const span = document.createElement('span');
      span.textContent = char === ' ' ? '\u00A0' : char;
      span.style.setProperty('--char-index', index); // ESTA LÍNEA ES CLAVE
      el.appendChild(span);
    });
  }

  typeEffect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        this.observer.unobserve(entry.target);
      }
    });
  }
}
